// V6 WEBSITE
export const NANOCOSMOS = "http://www.nanocosmos.de/";
export const CONTACT = "https://www.nanocosmos.de/contact";
export const DOCS = "https://docs.nanocosmos.de/";
export const SEND_MAIL = "sales@nanocosmos.de";
export const LEGAL_INFORMATION = "http://www.nanocosmos.de/legal";
export const LICENSING = "https://www.nanocosmos.de/blog/nanostream-cloud/licensing/";
export const BUY = "https://www.nanocosmos.de/v6/buy";
export const BINTU = "https://bintu.nanocosmos.de/";
export const SUPPORT = "https://www.nanocosmos.de/v6/support"
export const TERMS ="https://www.nanocosmos.de/nanostream/terms";
export const TRIAL = "https://www.nanocosmos.de/";
export const BLOG = "https://www.nanocosmos.de/blog/";
export const INFO = "https://info.nanocosmos.de/nanostreamcloud/";

export const H5LIVE = "https://nanocosmos.de/h5live";
export const CLOUD = "https://nanocosmos.de/cloud";
export const WEBCASTER = "https://www.nanocosmos.de/v6/#webrtc";
export const ANALYTICS = "https://www.nanocosmos.de/blog/2019/09/nanostream-analytics-get-insights-in-your-nanostream-cloud-service-and-h5live-player-performance/";
export const NANOMEET_DOCS = "https://docs.nanocosmos.de/docs/nanomeet/introduction?utm_source=nanoMeet_LandingPage&utm_medium=nanocosmos&utm_campaign=nanoMeet&utm_content=CTA_Developer"

// SOCIAL MEDIA
export const GITHUB = 'https://github.com/nanostream';
export const FACEBOOK = 'https://www.facebook.com/nanocosmos.net/';
export const YOUTUBE = 'https://www.youtube.com/channel/UCsWDxJax9j3GrMDufHBwgKA';
export const INSTAGRAM = 'https://www.instagram.com/nanovideo/';
export const LINKEDIN = 'https://www.linkedin.com/company/nanocosmos-gmbh/';
export const WEBSITE = 'https://info.nanocosmos.de/';
export const TWITTER = 'https://twitter.com/nanovideo';
